import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { FC, useCallback, useEffect } from 'react'

import { Operator } from 'core-components/types'
import { Logic } from 'core-components/types/ICrudHelpers'
import { CrudStore } from 'core/types/crudStore'

interface ISpecializationsMultiselectProps {
  className?: string
  value: string[]
  onChange: (newValue: string[]) => void
  partnersType: PartnerType
}

export const SpecializationsMultiselect: FC<ISpecializationsMultiselectProps> = ({
  className,
  partnersType,
  value,
  onChange,
}) => {
  const source = CrudStore.get(CrudStoreItemPartner360.JBPSpecializations)

  const handleChange = useCallback(
    (values: string[]) => {
      onChange(values)
    },
    [onChange]
  )

  useEffect(() => {
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'rtm',
          operator: Operator.EQUAL,
          value: partnersType,
        },
      ],
    })
  }, [source, partnersType])

  return (
    <MultiSelect
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      value={value}
      source={source}
      label="Specializations"
      caption="Specialization"
      onChange={handleChange}
    />
  )
}
